import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { IonButton, IonButtons, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonSearchbar, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { LetDirective } from '@ngrx/component';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { InformativeComponent } from 'src/app/components/informative/informative.component';
import { ItemComponent } from 'src/app/components/item/item.component';
import { SpinnerComponent } from 'src/app/components/spinner/spinner.component';
import { NavigableDirective } from 'src/app/directives/navigable.directive';
import { SearchedSheetItem } from 'src/app/services/sheets.service';
import { AppState } from 'src/app/store/reducers';
import { appendResultsRequested, newSearchRequested, resultsCleared, searchedSheetItemSelected } from 'src/app/store/sheet-item-search/sheet-item-search.actions';
import { morePagesExist, newSearchInProgress, queryTerm, searchResults } from 'src/app/store/sheet-item-search/sheet-item-search.selectors';

@Component({
	templateUrl: './item-search.modal.html',
	styleUrl: './item-search.modal.scss',
	imports: [
		LetDirective, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonSearchbar, IonInfiniteScroll, IonInfiniteScrollContent,
		ItemComponent, SpinnerComponent, InformativeComponent, NavigableDirective
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemSearchModal implements OnInit {

	@ViewChild(IonSearchbar, { static: false }) searchbar!: IonSearchbar;
	@ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll!: IonInfiniteScroll;

	queryTerm$: Observable<string>;
	newSearchInProgress$: Observable<boolean>;
	searchResults$: Observable<SearchedSheetItem[]>;
	morePagesExist$: Observable<boolean>;

	constructor(private modalController: ModalController, private store: Store<AppState>) {
		this.queryTerm$ = this.store.pipe(select(queryTerm));
		this.newSearchInProgress$ = this.store.pipe(select(newSearchInProgress));
		this.searchResults$ = this.store.pipe(select(searchResults)).pipe(tap(() => { if (this.infiniteScroll) this.infiniteScroll.complete() }));
		this.morePagesExist$ = this.store.pipe(select(morePagesExist));
	}

	ngOnInit() {
		setTimeout(() => this.searchbar.setFocus(), 500);
	}

	queryTermChanged(event: Event) {
		const queryTerm = (event as CustomEvent).detail.value.trim();
		if (queryTerm) {
			this.store.dispatch(newSearchRequested({ queryTerm: queryTerm }));
		}
		else {
			this.store.dispatch(resultsCleared());
		}
	}

	appendResults() {
		this.store.dispatch(appendResultsRequested());
	}

	async close() {
		await this.modalController.dismiss();
		this.store.dispatch(resultsCleared());
	}

	async itemSelected(item: SearchedSheetItem) {
		await this.modalController.dismiss();
		this.store.dispatch(searchedSheetItemSelected({ instructionTypeName: item.instructionTypeName }));
	}
}